import {defineMessages} from 'react-intl';

export default defineMessages({
	submit: {
		id: 'auth.login.submit',
		defaultMessage: 'Login',
	},
	title: {
		id: 'auth.login.title',
		defaultMessage: 'Login',
	},
	emailNotFound: {
		id: 'forms.fields.email.noempty',
		defaultMessage: 'Please enter your email address',
	},
	emailIsInvalid: {
		id: 'forms.fields.email.noinvalid',
		defaultMessage: 'Please enter a valid email address',
	},
	passwordNotFound: {
		id: 'forms.fields.password.noempty',
		defaultMessage: 'Please enter your password',
	},
	matchNotFound: {
		id: 'auth.login.nomatch',
		defaultMessage: 'Sorry, this does not match our records. Check your spelling and try again.',
	},
	unexpectedError: {
		id: 'common.error.unexpected',
		defaultMessage: 'An unexpected error occurred. Try again later.',
	},
	latinCharactersError: {
		id: 'forms.fields.name.error.latinCharacters',
		defaultMessage: 'Please enter Latin characters only',
	},
});
